var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('custom-link',_vm._b({scopedSlots:_vm._u([{key:"content",fn:function(){return [_vm._t("default")]},proxy:true}],null,true)},'custom-link',_vm.link,false)):_c('div',{staticClass:"custom-link"},[_c('div',{class:_vm.css_class},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }